export const tableSortHandler = (defaultColumn = '') => ({
  column: defaultColumn,
  descending: false,

  getApiColumn() {
    if (this.column == null || this.column === '') {
      return
    }

    return this.descending ? '-' + this.column : this.column
  },
})
